import { render, staticRenderFns } from "./QuickUpdate.vue?vue&type=template&id=7ef2723a&"
import script from "./QuickUpdate.vue?vue&type=script&lang=js&"
export * from "./QuickUpdate.vue?vue&type=script&lang=js&"
import style0 from "./QuickUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports